export { default } from "./CarNumberBox"
